var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "MX",
    clipPath: "url(#clip0_666_125)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    x: 0.3,
    y: -4.7,
    width: 31.4,
    height: 31.4,
    rx: 3.7,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_666_125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -5,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    x: 0.3,
    y: -4.7,
    width: 31.4,
    height: 31.4,
    rx: 3.7,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_666_125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask_3",
    x: 22,
    y: -5,
    width: 10,
    height: 32,
    fill: "#E3283E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    y: -5,
    width: 10,
    height: 32,
    fill: "#128A60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6939 10.0996C13.6445 9.70509 13.3079 9.3999 12.9001 9.3999C12.4583 9.3999 12.1001 9.75807 12.1001 10.1999C12.1001 11.6422 12.8705 12.9512 14.0949 13.6616C14.4771 13.8834 14.9666 13.7533 15.1884 13.3712C15.4101 12.989 15.2801 12.4995 14.8979 12.2777C14.162 11.8507 13.7001 11.0659 13.7001 10.1999L13.6939 10.0996ZM20.1001 10.1999C20.1001 9.75807 19.7419 9.3999 19.3001 9.3999C18.8583 9.3999 18.5001 9.75807 18.5001 10.1999C18.5001 11.0291 18.0771 11.7848 17.3909 12.2237C17.0187 12.4618 16.9099 12.9565 17.148 13.3287C17.386 13.7009 17.8807 13.8097 18.253 13.5716C19.3942 12.8417 20.1001 11.5806 20.1001 10.1999Z",
    fill: "#8C9157"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval 5_2",
    cx: 16.1,
    cy: 9.4,
    rx: 1.6,
    ry: 2.4,
    fill: "#C59262"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 -5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/MX.1b4b9274578d73ea261c33b6ebe6db2b.svg";
export { ForwardRef as ReactComponent };